import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {ENDPOINT_TYPES_MARCHE} from "../constants/endpoints";

let store = {
  debug: true,
  state: {
    typesMarche: []
  },

  getAll() {
    if (this.state.typesMarche.length === 0) {
      return axios.get(ENDPOINT_TYPES_MARCHE)
          .then(response => {
            this.state.typesMarche = response.data;
            return this.state.typesMarche;
          })
          .catch(error => AlertStore.pushError(error.response.data.message));
    } else {
      return new Promise(resolve => {
        resolve(this.state.typesMarche);
      });
    }
  }
};

export default store;
